import Vue from 'vue'
import VueRouter from 'vue-router'
import fetchAbsolute from 'fetch-absolute'
import { BootstrapVue } from 'bootstrap-vue'

import App from './App.vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'

Vue.config.productionTip = false
Vue.use(VueRouter)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faClipboard, faFileArchive } from '@fortawesome/free-solid-svg-icons'
import { faFirefox, faChrome } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faClipboard)
library.add(faFileArchive)
library.add(faFirefox)
library.add(faChrome)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(BootstrapVue)


let fetchOld = window.fetch
window.fetch = function(url, options) {
    if(options == null) {
        options = { }
    }
    options.credentials = 'include'
    return fetchAbsolute(fetchOld)(process.env.VUE_APP_API)(url, options)
      .then(res => {
        if(res.status === 401) {
            return Promise.all([router.push("/login"), new Promise(() => throw new Error("unauthorized"))])
        } else {
            return new Promise((resolve) => resolve(res))
        }
      })
}

new Vue({
  router: router,
  render: h => h(App),
}).$mount('#app')
